import { moodLevel } from "./config";
import { fmtMins, recoveryStats, themeGrid } from "./triggerInsights";

const avg = (a) => a.reduce((x, y) => x + y, 0) / a.length;

export function insightsSpeech(sessions, data, weekly) {
  const parts = ["Here's a gentle look at your patterns."];
  if (weekly?.text) parts.push(`Your week: ${weekly.text}`);
  const moods = [...sessions].reverse().filter((s) => s.moodNow != null).map((s) => s.moodNow);
  if (moods.length >= 2) {
    const recent = moods.slice(-5), before = moods.slice(-10, -5);
    const a = avg(recent);
    let line = `Lately your mood has averaged around ${moodLevel(Math.round(a))?.label?.toLowerCase() ?? Math.round(a)}`;
    if (before.length) { const d = a - avg(before); line += d > 0.5 ? ", a little brighter than before" : d < -0.5 ? ", a little lower than before — harder stretches happen" : ", holding steady"; }
    parts.push(`${line}.`);
  }
  if (data.streak) parts.push(`You're on a ${data.streak}-day mood streak.`);
  if (data.liftRows.length) parts.push(`What seems to lift you most: ${data.liftRows.slice(0, 3).map((r) => r[0]).join(", ")}.`);
  else if (data.coping.length) parts.push(`The tools you reach for most: ${data.coping.slice(0, 3).map((r) => r[0]).join(", ")}.`);
  const g = themeGrid(sessions);
  if (g.hardest) parts.push(`The trigger theme that tends to hit hardest is ${g.hardest.theme}, which came up ${g.hardest.n} times.`);
  const r = recoveryStats(sessions);
  if (r.count) parts.push(`On average it takes you about ${fmtMins(r.avg).replace(/^1 h /, "1 hour ").replace(" h ", " hours ").replace("min", "minutes")} to get back to calm.${r.message ? ` ${r.message}` : ""}`);
  if (data.needs.total) parts.push(`The needs that come up most are ${data.needs.items.slice(0, 3).map((n) => n[0]).join(", ")}.`);
  if (data.wins.total) parts.push(`And you've had ${data.wins.total} Healthy Adult win${data.wins.total === 1 ? "" : "s"}. That matters.`);
  parts.push("Be gentle with yourself — every check-in is a step toward understanding.");
  return parts.join(" ").slice(0, 3900);
}
